import spolistService from 'services/spolist.service'

const state = {
    loading: false,
    regions: [],
    cities: [],
    hotels: [],
    priceTypes: [
        { value: '', label: 'Любой' },
        { value: 1, label: 'Контрактные' },
        { value: 2, label: 'СПО' },
    ],
    report: null
}

const getters = {
    priceTypes: state => state.priceTypes
}

const mutations = {
    setRegions(state, regions = []) {
        state.regions = regions;
    },
    setCities(state, cities = []) {
        state.cities = cities;
    },
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setPriceTypes(state, priceTypes = []) {
        state.priceTypes = priceTypes;
    },
    setLoading(state, loading = false) {
        state.loading = loading;
    },
    setReport(state, report) {
        state.report = report;
    }
}

const actions = {
    getRegions({ commit }) {
        spolistService.getRegions().then(response => {
            commit('setRegions', response);
        }).catch(() => {
        })
    },

    setLoading({ commit }, loading = false) {
        commit('setLoading', loading);
    },

    downloadSpoListReport({ commit }, params) {
        commit('setLoading', true);
        return spolistService.downloadSpoListReport(params).then(response => {
            commit('setLoading', false);
            commit('setReport', response);
            return response;
        }).catch(() => {
            commit('setLoading', false);
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
